export enum TradingAlertRuleType {
    PRICE = "PRICE",
    ADX = "ADX"
}
